module.exports = __webpack_public_path__ + "img/type_FLYING.ff18e913.png";